import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Row } from "react-bootstrap";
import { productsList, wishlistIcon } from "../SvgPaths/SvgPaths";
import { getRelatedProducts } from "../../services/RelatedProductsService";
import wishlistSelectedIcon from "../../assets/images/png/wishlistSelectedIcon.png";
import Clock from "../../assets/images/png/green-clock-icon.png";
import Location from "../../assets/images/png/location-icon.png";
import Tag from "../../assets/images/png/tag-icon.png";
import likeicon from "../../assets/images/png/like-icon.png";
import {
  addProducttoWishlist,
  getWishlistProducts,
} from "../../services/WishlistServices";

const RelatedProducts = ({
  heading,
  heading2,
  display_none,
  productsId,
  productsReload,
}) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const relatedProductId = id || productsId;
  const [relatedProduct, setRelatedProduct] = useState([]);
  const [favouriteItems, setFavouriteItems] = useState([]);
  const [pageNumber, setPageNumber] = useState(4);
  const [totalPages, setTotalPages] = useState();
  const getProducts = async () => {
    const res = await getRelatedProducts(relatedProductId, pageNumber);
    setRelatedProduct(res?.products);
    setTotalPages(res?.totalPages);
  };

  const getWishlistItems = async () => {
    const tokenitem = localStorage.getItem("token");
    const res = await getWishlistProducts(tokenitem);
    setFavouriteItems(res);
  };
  const addToWishlist = async (id) => {
    const tokenitem = localStorage.getItem("token");
    if (tokenitem) {
      const productId = id;
      await addProducttoWishlist(productId, tokenitem);
      getWishlistItems();
    } else {
      localStorage.setItem("path", "/farmer-shop");
      navigate("/signin");
    }
  };
  const isInWishlist = (id) => {
    return (
      favouriteItems &&
      favouriteItems.some((item) => item?.productId?._id === id)
    );
  };

  useEffect(() => {
    getProducts();
    getWishlistItems();
  }, [pageNumber]);

  function convertToRelativeTime(createdAt) {
    const currentTime = new Date();
    const createdTime = new Date(createdAt);
    const timeDifference = Math.abs(currentTime - createdTime);

    const seconds = Math.floor(timeDifference / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (days > 0) {
      return `${days} day${days > 1 ? "s" : ""} ago`;
    } else if (hours > 0) {
      return `${hours} hour${hours > 1 ? "s" : ""} ago`;
    } else if (minutes > 0) {
      return `${minutes} minute${minutes > 1 ? "s" : ""} ago`;
    } else {
      return `just now`;
    }
  }

  return (
    <>
      <div className="py-5">
        <div className="container">
          <h2 className="ff_heebo fw-bold fs_7xl clr_dark_blue text-center">
            {heading} <span className="clr_dark_green">{heading2}</span>
          </h2>
          <div>
            <p className="text-center ff_heebo mx-auto clr_dark_grey_2 fs_md mt-3">
              You may also like these products. Explore similar items to find
              the perfect fit for your needs <br /> Discover quality and value
              with our top picks.
            </p>
            <Row>
              {relatedProduct &&
                relatedProduct.map((item, index) => (
                  <div className="col-lg-3 col-md-4 col-sm-6 pt-4" key={index}>
                    {item.productType === "machinery" ? (
                      <div className="h-100">
                        <div className="rounded-3 product-border d-flex flex-column justify-content-between yellow-bg-hover related-products-card h-100 cursor-pointer">
                          <div
                            onClick={() =>
                              navigate(`/profile-details/${item?._id}`)
                            }
                          >
                            <div
                              style={{ borderRadius: "8px 8px 0 0" }}
                              className="position-relative bg-white"
                            >
                              <span
                                className={`position-absolute top-0 end-0 mt-2 text-white py-1 px-3 rounded-2 me-2 fs_3xsm ${
                                  item?.adType === "sales"
                                    ? "bg_red"
                                    : item?.adType === "lease"
                                    ? "bg-purple"
                                    : "bg_clr_green"
                                } ff_heebo fs_3xsm text-capitalize`}
                              >
                                {item?.adType}
                              </span>
                              <img
                                height={200}
                                style={{ borderRadius: "8px 8px 0 0" }}
                                className="w-100 object-fit-cover "
                                src={item?.images[0]}
                                alt="Image"
                              />
                            </div>
                            <div className="px-3 pt-3">
                              <div className="d-flex align-items-center">
                                <img src={Tag} alt="tag" />{" "}
                                <span className="clr_dark_green ff_heebo fs_3xsm ms-3">
                                  {item?.machineType} / Agri Equipments
                                </span>
                              </div>
                              <h3 className="ff_heebo fs_md my-3 fw-semibold clr_dark_blue">
                                {item?.name}
                              </h3>
                              <div className="d-flex align-items-center">
                                <div>
                                  <img
                                    className="mb-10"
                                    src={Location}
                                    alt="tag"
                                  />
                                </div>{" "}
                                <span className="clr_dark_green ff_heebo fs_3xsm ms-1">
                                  {item?.location}
                                </span>
                                <div className="ms-3">
                                  {" "}
                                  <img
                                    className="mb-10"
                                    src={Clock}
                                    alt="tag"
                                  />
                                </div>{" "}
                                <span className="clr_dark_green ff_heebo fs_3xsm ms-1">
                                  {convertToRelativeTime(item?.createdAt)}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="px-3">
                            <div className="hr-line my-3"></div>
                            <div className="d-flex align-items-center justify-content-between  pb-3">
                              <div
                                onClick={() => navigate("/profile-details")}
                                className="d-flex-align-items-center w-100"
                              >
                                <span className="fw-bold ff_heebo fs_md clr_dark_blue">
                                  ₹{item?.price}
                                </span>
                                <span className="clr_dark_green ff_heebo fs_3xsm">
                                  /{item?.priceType}
                                </span>
                              </div>
                              <div className="d-flex align-items-center gap-2">
                                <div
                                  onClick={() => navigate("/profile-details")}
                                  className="vr-line"
                                ></div>
                                <div
                                  onClick={() => {
                                    addToWishlist(item._id);
                                  }}
                                  className="d-flex"
                                >
                                  {isInWishlist(item?._id) ? (
                                    <img
                                      className="postion-relative z-3"
                                      width={18}
                                      src={wishlistSelectedIcon}
                                      alt="wishlistIcon"
                                    />
                                  ) : (
                                    <img
                                      className="postion-relative z-3"
                                      width={18}
                                      src={likeicon}
                                      alt="wishlistIcon"
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div
                        className={` yellow-bg-hover cursor_pointer position-relative related-products-card h-100 d-flex flex-column justify-content-between rounded-2 pb-3`}
                      >
                        <div
                          onClick={() =>
                            navigate(`/product-details/${item._id}`)
                          }
                        >
                          {item.discountPrice && item.price && (
                            <span className="mb-0 bg_clr_yellow text-white px-3 py-1 rounded-2 ff_heebo fs_3xsm position-absolute discount-percentage">
                              {Math.round(
                                ((item.price - item.discountPrice) /
                                  item.price) *
                                  100
                              )}
                              % Off
                            </span>
                          )}
                          <div
                            style={{ borderRadius: "8px 8px 0 0 " }}
                            className="bg-white pt-2 text-center pb-2"
                          >
                            <img
                              style={{
                                width: "200px",
                                height: "200px",
                              }}
                              className="object-fit-contain"
                              src={item.images?.[0]}
                              alt=""
                            />
                          </div>
                          <p className="ff_heebo fw-medium fs_md clr_dark_blue pe-2 mt-3 mb-0 text-capitalize px-3">
                            {item.name}
                          </p>
                        </div>
                        <div className="row align-items-center justify-content-between mt-2 px-3">
                          <div className="hr-line mt-3"></div>
                          <div
                            onClick={() =>
                              navigate(`/product-details/${item._id}`)
                            }
                            className="col-10 pe-0 mt-2"
                          >
                            <div className=" d-flex align-items-center justify-content-between">
                              <p className="ff_arial fw-bold fs_md mb-0 text-black">
                                {item.discountPrice}
                                <span className="fs_4xsm fw-normal clr_dark_green">
                                  /
                                  <span className="text-decoration-line-through">
                                    ₹ {item.price}
                                  </span>
                                </span>
                              </p>
                            </div>
                          </div>
                          <div className="col-2 ps-0">
                            <div className="d-flex align-items-center justify-content-end gap-3">
                              <div
                                onClick={() =>
                                  navigate(`/product-details/${item._id}`)
                                }
                                className="vr-line"
                              ></div>
                              <div
                                onClick={() => {
                                  addToWishlist(item._id);
                                }}
                              >
                                {isInWishlist(item?._id) ? (
                                  <img
                                    className="postion-relative z-3"
                                    width={18}
                                    src={wishlistSelectedIcon}
                                    alt="wishlistIcon"
                                  />
                                ) : (
                                  <img
                                    className="postion-relative z-3"
                                    width={18}
                                    src={likeicon}
                                    alt="wishlistIcon"
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
            </Row>
            <div className={`text-center mt-4 pt-2 mb-5 ${display_none}`}>
              {totalPages > 1 ? (
                <button
                  onClick={() => {
                    setPageNumber(pageNumber + 4);
                  }}
                  style={{ width: "160px", height: "40px", paddingTop: "3px" }}
                  className="common-darkgreen-button text-uppercase mx-auto px-4 ff_heebo fw-medium text-white text-uppercase rounded-3 fs_xxsm"
                >
                  View More
                </button>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RelatedProducts;
